module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds@2x.28fe607.webp";